module.exports = __webpack_public_path__ + "img/icon_deco.7d11cfe3.svg";